import { useNavigate } from "react-router-dom";


const useNav = () => {

  const nav = useNavigate();

  const goBack = () => nav(-1);


  return {
    goBack,
    navTo: nav
  };
}

export default useNav;
